import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapyCzOrthoPhotoLayer = _resolveComponent("MapyCzOrthoPhotoLayer")!
  const _component_LControl = _resolveComponent("LControl")!
  const _component_LMarker = _resolveComponent("LMarker")!
  const _component_LMap = _resolveComponent("LMap")!

  return (_openBlock(), _createBlock(_component_LMap, {
    center: _ctx.coordinates,
    zoom: _ctx.zoom,
    class: "flex-grow-1",
    onReady: _ctx.onMapReady,
    ref: "container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_MapyCzOrthoPhotoLayer),
      _createVNode(_component_LControl, { position: "bottomleft" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: `https://mapy.cz/letecka?x=${_ctx.longitude}&y=${_ctx.latitude}&z=${_ctx.zoom}`,
              target: "_blank"
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", { src: "https://api.mapy.cz/img/api/logo.svg" }, null, -1)
            ]))], 8, _hoisted_1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_LMarker, {
        "lat-lng": _ctx.coordinates,
        icon: _ctx.markerIcon
      }, null, 8, ["lat-lng", "icon"])
    ]),
    _: 1
  }, 8, ["center", "zoom", "onReady"]))
}